// Le compteur d'adaptations de la semaine (issue #120), sous le bouton qui
// adapte un CV dans Radar. Une adaptation est une offre : le CV, la lettre et
// leurs retouches comptent pour un. Rien ne s'affiche en formule Complet
// (illimité) ni si le serveur ne répond pas : le refus 429, lui, se lit dans
// la notification d'erreur.

import { get } from '../lib/api'
import { useData } from './common'
import { useT } from '../lib/i18n'
import { useFormule } from '../lib/formule'

export interface QuotaAdaptations {
  utilisees: number
  limite: number | null
  restantes: number | null
  remise: string
  formule: string
}

export function CompteurAdaptations() {
  const t = useT()
  const radar = useFormule() === 'radar'
  const q = useData(() => (radar ? get<QuotaAdaptations>('/api/radar/quota') : Promise.resolve(null)), [radar])
  const d = q.data
  if (!radar || !d || d.restantes === null || d.limite === null) return null
  return (
    <span className={`hint${d.restantes === 0 ? ' avertissement' : ''}`}>
      {d.restantes === 0 ? t('quota.aZero') : t('quota.restantes', { n: d.restantes, max: d.limite })}
    </span>
  )
}
